import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'

import { CompImageWrapperCore } from '../core/image/wrapper'
import { CompImage } from './CompImage'

/**
 * CompImageWrapper
 */
function CompImageWrapper() {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // action
  const actionContext = useBuilderActionContextV2()

  return (
    <CompImageWrapperCore infos={infosProps} action={actionContext}>
      {(props) => <CompImage {...props} />}
    </CompImageWrapperCore>
  )
}


export default CompImageWrapper